import React, { useEffect } from 'react';
import { common, textStyles } from '../../assets/theme';
import { css, StyleSheet } from 'aphrodite/no-important';
import QuoteNavbar from '../../components/navigation/quoteNavbar';
import { NAVBAR_HEIGHTS } from 'shared/constants';
import i18n from '../../i18n';
import FancyLink from '../../components/fancyLink';

const NotFoundContainer = () => {
    // useEffect(() => {
    //     window.gtag('event', 'page_view', {
    //         page_location: window.location.href,
    //         page_path: window.location.pathname,
    //         page_title: document.title,
    //     });
    // }, [window.location.href]);
    return (
        <>
            <QuoteNavbar />
            <div className={css(styles.screenContainer)}>
                <div className={css(styles.pageContainer)}>
                    <div>
                        <h1 className={css(styles.pageTitle)}>{i18n.t('notFound.title')}</h1>
                        <div className={css(styles.buttonContainer)}>
                            <FancyLink
                                linkTo="/quote"
                                buttonType="secondary"
                                className={styles.linkContainer}
                            >
                                <span className={css(styles.primaryBoldText)}>
                                    {i18n.t('notFound.startQuote')}
                                </span>
                            </FancyLink>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const styles = StyleSheet.create({
    screenContainer: {
        paddingTop: NAVBAR_HEIGHTS.mobile,

        [common.mediaQuery.minMd]: {
            paddingTop: NAVBAR_HEIGHTS.desktop,
        },
    },
    pageTitle: {
        ...textStyles.h1,
    },
    pageSubTitle: {
        ...textStyles.h2,
    },
    pageContainer: {
        maxWidth: 1200,
        padding: 0,
        marginLeft: '.5rem',
        marginRight: '.5rem',
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center',
        justifyContent: 'center',
        minHeight: '50vh',
        [common.mediaQuery.minMd]: {
            margin: '0 auto',
            paddingLeft: '2rem',
            paddingRight: '2rem',
        },
    },
    buttonContainer: {
        display: 'flex',
        minWidth: 300,
        paddingTop: 40,
    },
    linkContainer: {
        marginLeft: 8,
        marginRight: 8,
    },
});

export default NotFoundContainer;
